import rootActions from "../rootActions";

class shopActions extends rootActions {
  constructor(params) {
    super(params);
  }
}

export default shopActions;
